export default __webpack_public_path__ + "static/E_80-fd21ea78d8364401b05778418db25152.png";